import React from "react";

function DotGrayIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g
        id="Group_27221"
        data-name="Group 27221"
        transform="translate(12376 23404)"
      >
        <path
          id="Path_18533"
          data-name="Path 18533"
          d="M0,0H32V32H0Z"
          transform="translate(-12376 -23404)"
          fill="rgba(255,0,0,0.53)"
          opacity="0"
        />
        <g
          id="Group_124"
          data-name="Group 124"
          transform="translate(-12357 -23376) rotate(-180)"
        >
          <path
            id="Path_117"
            data-name="Path 117"
            d="M5.121.852a2.846,2.846,0,0,1,0,4.114,3.067,3.067,0,0,1-4.243,0,2.847,2.847,0,0,1,0-4.114,3.067,3.067,0,0,1,4.243,0"
            transform="translate(0 0)"
            fill="#596970"
          />
          <path
            id="Path_118"
            data-name="Path 118"
            d="M5.121.852a2.846,2.846,0,0,1,0,4.114,3.067,3.067,0,0,1-4.243,0,2.846,2.846,0,0,1,0-4.114,3.067,3.067,0,0,1,4.243,0"
            transform="translate(0 9.091)"
            fill="#596970"
          />
          <path
            id="Path_119"
            data-name="Path 119"
            d="M5.121.852a2.846,2.846,0,0,1,0,4.114,3.066,3.066,0,0,1-4.243,0,2.846,2.846,0,0,1,0-4.114,3.066,3.066,0,0,1,4.243,0"
            transform="translate(0 18.182)"
            fill="#596970"
          />
        </g>
      </g>
    </svg>
  );
}

export default DotGrayIcon;
